var map = {
	"./account.svg": "4411",
	"./account_dark.svg": "a271",
	"./activities_dark.svg": "b9d8",
	"./activity.svg": "0dd6",
	"./analysis.svg": "1c1c",
	"./billing.svg": "6279",
	"./billing_dark.svg": "1025",
	"./consignments.svg": "c4306",
	"./consignments_dark.svg": "c85d",
	"./contacts.svg": "21f5",
	"./contacts_dark.svg": "fc97",
	"./credit_dark.svg": "ab1a",
	"./credits.svg": "b77c",
	"./expense_dark.svg": "67e2",
	"./expenses.svg": "ab3b",
	"./metrices.svg": "8644",
	"./metrices_dark.svg": "dc18",
	"./orders.svg": "3b7e",
	"./orders_dark.svg": "c078",
	"./products.svg": "eb21",
	"./products_dark.svg": "48a6",
	"./recordDetails_dark.svg": "43bd",
	"./sale_dark.svg": "124d",
	"./sales.svg": "a623",
	"./security.svg": "133d",
	"./services.svg": "b11f",
	"./staff.svg": "e214",
	"./staff_dark.svg": "3abc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "46bc";